<template>
    <v-container v-resize="onResize">
        <h2  v-if="!loading && this.committee != null">{{ this.committee.CommitteeName}}</h2>
        <v-layout v-if="!loading && this.committee != null" row wrap align-center>
            
            <v-flex xs12 md6>
                <h3 class="pt-3">
                    <v-chip large label :color="this.committee.CommitteeChamber == 'Senate' ? $store.state.COLOUR_SENATE 
                        : (this.committee.CommitteeChamber == 'House' ? $store.state.COLOUR_REPRESENTATIVES
                        : $store.state.COLOUR_JOINT)" >
                        {{ this.committee.CommitteeType }}
                    </v-chip> Committee members served between {{ this.committee.ServiceStartDate | stringDateFormat }} 
                    and {{ this.committee.Current ? "current" : "" }}
                    {{ this.committee.ServiceEndDate | stringDateFormat }} {{ this.committee.Current ? '' : ' (Former committee)'}} </h3>
            </v-flex>
            <v-flex xs12 sm6 md3>
                <v-card-title class="pb-0 mb-0">
                    <v-text-field
                      :class="{mobileTextField: isMobile}" 
                      v-on:keyup="TRACK_SEARCH"
                      v-model="search"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-menu v-if="this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                        <v-btn outline small slot="activator">
                            Sort <v-icon>sort</v-icon>
                        </v-btn>
                        <v-list>
                            <v-subheader>
                                Sort by:
                            </v-subheader>
                            <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                                <v-list-tile-title>
                                    {{ item.text }}
                                    <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-card-title> 
            </v-flex>
            <v-flex xs12 sm6 md3>
                  <v-card-title class="pb-0 mt-3 mb-0">
                    <v-autocomplete
                      label="Select a Parliament"
                      v-model="SELECTED_PARLIAMENTS"
                      :items="ENABLED_PARLIAMENTS"
                      item-text="Name"
                      item-value="PID"
                      v-on:change="FILTERBY_PARLIAMENT"
                      auto-select-first
                      multiple
                       clearable
                      small-chips
                      deletable-chips
                    >
                    <template v-slot:selection="{ item, index }">
                        <v-chip @input="deleteParliamentSelectionItem(item.Name)" small close v-if="index == 0">{{item.Name}}</v-chip>
                        <v-chip small v-if="index == 1">+ {{SELECTED_PARLIAMENTS.length - 1}} more</v-chip>
                    </template>
                    <template
                        v-slot:prepend-item
                        v-if="this.$store.getters.GET_PARLIAMENTS.length > 0"
                      >
                        <v-list-tile
                          v-on:click="CLICK_CURRENTPARLIAMENT"
                          :value="currentParliamentValue"
                          ripple
                        >
                          <v-list-tile-action>
                            <v-icon>{{ currentParliamentIcon }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title
                              >Current Parliament</v-list-tile-title
                            >
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-card-title>
                </v-flex>
        </v-layout>
        <template>
            <v-card v-if="loading">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="loader"></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
            <br/>
        </template>

        
      <div class="stats-table"> 
        <v-data-table v-if="!loading" :headers="HEADERS" :items="committeeRecords"
            :rows-per-page-items="ROWS_LISTITEMS"
            fixed-header
            height="100vh"
            :custom-sort="customSort"
            :pagination.sync="PAGINATION" 
            :hide-headers="isMobile"
            :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
            v-on:update:pagination="UPDATE_PAGINATION"
            :expand="expand" item-key="PHID" >
            <template v-slot:items="props">
                <router-link v-if="isMobile" class="tr" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}" >
                    <td>
                        <div class="flex-content">
                            <div class="flex-item">
                                <h3 class="pb-xs-1">{{ props.item.Name }}</h3>
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-30">
                                <div class="flex-item">
                                    <Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait>
                                </div>
                            </div>
                            <div class="flex-item flex-item-col flex-item-col-70">
                                <div class="flex-item flex-item-col" data-label="Position">
                                    <div v-for="(service, index) in props.item.ServiceList" :key="index">
                                        <span v-if="(props.item.TruncatePositions && index == 0) || !props.item.TruncatePositions">{{ service.PositionType }}</span>
                                    </div>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-50" data-label="Start date">
                                     <div v-for="(service, index) in props.item.ServiceList" :key="index">
                                        <span v-if="service.StartDate != '0001-01-01T00:00:00'">
                                            {{ service.StartDate | stringDateFormat}}
                                        </span>
                                        <br/>
                                    </div>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-50" data-label="End date">
                                    <div v-for="(service, index) in props.item.ServiceList" :key="index">
                                        <span v-if="service.EndDate != '0001-01-01T00:00:00'">
                                            {{ service.EndDate | stringDateFormat}}
                                        </span>
                                        <span v-if="service.EndDate == '0001-01-01T00:00:00'">Current</span>
                                        <br/>
                                    </div>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-50" data-label="State">
                                     <div v-for="(service, index) in props.item.ServiceList" :key="index">
                                        <span v-if="(props.item.TruncateStates && index == 0) || !props.item.TruncateStates">{{ service.States.toUpperCase() }}</span>
                                    </div>
                                </div>
                                <div class="flex-item flex-item-col flex-item-col-50" data-label="Chamber">
                                    <div v-for="(service, index) in props.item.ServiceList" :key="index">
                                        <span v-if="(props.item.TruncateChambers && index == 0) || !props.item.TruncateChambers">{{ service.Chambers.replace('Member', 'House').replace('Senator', 'Senate') }}</span>
                                    </div>
                                </div>
                                <div class="flex-item" data-label="Party">
                                    <div v-for="(service, index) in props.item.ServiceList" :key="index">
                                        <span v-if="(props.item.TruncateParties && index == 0) || !props.item.TruncateParties">{{ service.Parties }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </router-link>
                <router-link v-else class="tr" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}">
                    <td class="text-xs-left">
                        <Portrait v-bind:fixedWidth="80" v-bind:PHID="props.item.PHID"></Portrait>
                    </td>
                    <td class="text-xs-left">{{ props.item.Name }}</td>
                    <td class="text-xs-left">
                        <div v-for="(service, index) in props.item.ServiceList" :key="index">
                            <span v-if="service.StartDate != '0001-01-01T00:00:00'">
                                {{ service.StartDate | stringDateFormat}}
                            </span>
                            <br/>
                        </div>
                    </td>
                    <td class="text-xs-left">
                        <div v-for="(service, index) in props.item.ServiceList" :key="index">
                            <span v-if="service.EndDate != '0001-01-01T00:00:00'">
                                {{ service.EndDate | stringDateFormat}}
                            </span>
                            <span v-if="service.EndDate == '0001-01-01T00:00:00'">Current</span>
                            <br/>
                        </div>
                    </td>
                    <td class="text-xs-left">
                        <div v-for="(service, index) in props.item.ServiceList" :key="index">
                            <span v-if="(props.item.TruncatePositions && index == 0) || !props.item.TruncatePositions">{{ service.PositionType }}</span>
                        </div>
                    </td>
                    <td class="text-xs-left">
                        <div v-for="(service, index) in props.item.ServiceList" :key="index">
                            <span v-if="(props.item.TruncateStates && index == 0) || !props.item.TruncateStates">{{ service.States.toUpperCase() }}</span>
                        </div>
                    </td>
                    <td class="text-xs-left">
                        <div v-for="(service, index) in props.item.ServiceList" :key="index">
                            <span v-if="(props.item.TruncateParties && index == 0) || !props.item.TruncateParties">{{ service.Parties }}</span>
                        </div>
                    </td>
                    <td class="text-xs-left">
                        <div v-for="(service, index) in props.item.ServiceList" :key="index">
                            <span v-if="(props.item.TruncateChambers && index == 0) || !props.item.TruncateChambers">{{ service.Chambers.replace('Member', 'House').replace('Senator', 'Senate') }}</span>
                        </div>
                    </td>
                </router-link>
            </template>
            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </template>
        </v-data-table>
        </div>

        <v-layout row wrap>
            <v-flex xs12>
                <div style="float:right">
                    <!-- <v-btn class="csvButton" color="primary">
                        <v-icon aria-hidden="true" :class="pdfDownloadClass">{{pdfDownloadIcon}}</v-icon>
                        <span v-on:click="EXPORT_COMMITTEE_PDF">&nbsp;Download as PDF</span>
                    </v-btn>  -->
                    <v-btn v-on:keyup.enter="EXPORT_COMMITTEE_CSV"  color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span v-on:click="EXPORT_COMMITTEE_CSV">&nbsp;Download as CSV</span>
                    </v-btn>
                </div>
            </v-flex>
        </v-layout>

        <br />
<!-- <h3 v-if="!loading" >Demographics</h3>
         <chart v-if="!loading" :chartData="committeeStateDemographics" />
         <chart v-if="!loading" :chartData="committeePartyDemographics" />
         <chart v-if="!loading" :chartData="committeeChamberDemographics" />
         <chart v-if="!loading" :chartData="committeeGenderDemographics" /> -->
    </v-container>
</template>

<script>
    window.scrollTo(0, 0);
    import axios from 'axios'
     import Portrait from '@/components/Portrait.vue'
    //  import moment from 'moment'
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri; 
    // import Chart from "../StatisticalInformation/Chart.vue";   

    export default {
        components: {
            Portrait,
            // Chart
        },
        props: {
            CID: {
                type: String,
                required: true,
            },
            parliaments: {
                type: Array,
                required: false
            }
        },
        created() {
            this.loadData();
        },
        data() {
            return {
                isMobile: false,
                expand: true,
                expanded:[],
                committeeName:'',
                committeeType:'',
                search: '',
                pdfDownloading: false,
                csvDownloading: false,
                loading: true,
                committeeRecords: [],
                committeeRecordsOriginal: [],
                committeeService: [],
                genderDemographics: [],
                partyDemographics: [],
                stateDemographics: [],
                chamberDemographics: [],
                PARLIAMENTLIST: this.$store.getters.GET_PARLIAMENTS,
                SELECTED_PARLIAMENTS: [],
                ENABLED_PARLIAMENTS: [],
                RECORDS1: [],
                parties: [],
                ROWS_LISTITEMS: [10, 20, 50, 100, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],
                committee: {
                    type: Object,
                    default: () => ({})
                },
                PAGINATION: {
                    rowsPerPage: 50,
                    sortBy: ''
                },
                HEADERS: [
                    {
                        text: 'Image',
                        value: 'PHID',
                        align: 'left',
                        sortable: false,
                        filterable: false,
                        width: '100px'
                    },
                    {
                        text: 'Parliamentarian name',
                        value: 'Name',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        text: 'Service start',
                        value: 'StartDate',
                        align: 'left',
                        sortable: true,
                        width: '100px'
                    
                    },
                    {
                        text: 'Service end',
                        value: 'EndDate',
                        align: 'left',
                        sortable: true,
                        width: '100px'
                    },
                    {
                        text: 'Position',
                        value: 'PositionType',
                        align: 'left',
                        width: '200px'
                    },
                    {
                        text: 'State',
                        value: 'States',
                        align: 'left',
                        width: '100px'
                    },
                    {
                        text: 'Party',
                        value: 'Parties',
                        align: 'left',
                        width: '200px'
                    },
                    {
                        text: 'Chamber',
                        value: 'Chambers',
                        align: 'left',
                        width: '100px'
                    },
                ],
            }
        },

        methods: {
            onResize() {
                if (window.innerWidth < 769){
                    this.isMobile = true;
                }
                else{
                    this.isMobile = false;
                }
            },
            changeSort(column) {
                if (this.PAGINATION.sortBy === column) {
                    this.PAGINATION.descending = !this.PAGINATION.descending
                } 
                else {
                    this.PAGINATION.sortBy = column
                    this.PAGINATION.descending = false
                }
            },
            deleteParliamentSelectionItem(item) {
                this.SELECTED_PARLIAMENTS = this.SELECTED_PARLIAMENTS.filter(find => find.Name !== item.Name);
                this.FILTERBY_PARLIAMENT(this.SELECTED_PARLIAMENTS);
            },
            getDateDiff(start, end){
                var diff = Math.floor(( new Date(end).getTime() - new Date(start).getTime()) / 86400000) + 1;
        
                const years = Math.floor(diff / 365);
                const months = Math.floor((diff - years * 365) / 30);
                const d = Math.round(diff - years * 365 - months * 30);

                let res = [];
                if (years > 1) {
                    res.push(years + ' years');
                }
                if (years == 1) {
                    res.push(years + ' year');
                }
                if (months > 1) {
                    res.push(months + ' months');
                }
                if (months == 1) {
                    res.push(months + ' month');
                }
                if (d > 1) {
                    res.push(d + ' days');
                }
                if (d == 1) {
                    res.push(d + ' day');
                }
                let initialDiff = diff > 1 ? diff + ' days' : diff + ' day';
                let detailDiff = res.join(', ');

                if (initialDiff === detailDiff){
                    return initialDiff
                }
                else { 
                    return initialDiff + ' (' + detailDiff + ')';
                }
            },
            getDateLength(days){
                const years = Math.floor(days / 365);
                const months = Math.floor((days - years * 365) / 30);
                const d = Math.round(days - years * 365 - months * 30);

                let res = [];
                if (years > 1) {
                    res.push(years + ' years');
                }
                if (years == 1) {
                    res.push(years + ' year');
                }
                if (months > 1) {
                    res.push(months + ' months');
                }
                if (months == 1) {
                    res.push(months + ' month');
                }
                if (d > 1) {
                    res.push(d + ' days');
                }
                if (d == 1) {
                    res.push(d + ' day');
                }
                let initialDiff = days > 1 ? days + ' days' : days + ' day';
                let detailDiff = res.join(', ');

                if (initialDiff === detailDiff){
                    return initialDiff
                }
                else { 
                    return initialDiff + ' (' + detailDiff + ')';
                }
            },
            customSort(items, index, isDesc) {
                items.sort((a, b) => {
                    if (index === 'StartDate') {
                        if (!isDesc) {
                            a.ServiceList = a.ServiceList.sort((c, d) => (c.StartDate > d.StartDate) ? 1 : -1)
                            b.ServiceList = b.ServiceList.sort((c, d) => (c.StartDate > d.StartDate) ? 1 : -1)
                            const aService = a.ServiceList[0].StartDate;
                            const bService = b.ServiceList[0].StartDate;
                            return aService < bService ? -1 : 1;
                        } else {
                            a.ServiceList = a.ServiceList.sort((c, d) => (c.StartDate < d.StartDate) ? 1 : -1)
                            b.ServiceList = b.ServiceList.sort((c, d) => (c.StartDate < d.StartDate) ? 1 : -1)
                            const aService = a.ServiceList[0].StartDate;
                            const bService = b.ServiceList[0].StartDate;
                            return bService < aService ? -1 : 1;
                        }
                    }
                    else if (index === 'EndDate') {
                        if (!isDesc) {
                            a.ServiceList = a.ServiceList.sort((c, d) => (c.EndDate > d.EndDate) ? 1 : -1)
                            b.ServiceList = b.ServiceList.sort((c, d) => (c.EndDate > d.EndDate) ? 1 : -1)
                            const aService = a.ServiceList[0].EndDate;
                            const bService = b.ServiceList[0].EndDate;
                            if (aService == null || aService == '0001-01-01T00:00:00') {
                                return 1;
                            }
                            else if (bService == null || bService == '0001-01-01T00:00:00') {
                                return -1;
                            }
                            return aService < bService ? -1 : 1;
                        } else {
                            a.ServiceList = a.ServiceList.sort((c, d) => (c.EndDate < d.EndDate) ? 1 : -1)
                            b.ServiceList = b.ServiceList.sort((c, d) => (c.EndDate < d.EndDate) ? 1 : -1)
                            const aService = a.ServiceList[0].EndDate;
                            const bService = b.ServiceList[0].EndDate;
                            if (aService == null || aService == '0001-01-01T00:00:00') {
                                return -1;
                            }
                            else if (bService == null || bService == '0001-01-01T00:00:00') {
                                return 1;
                            }
                            return bService < aService ? -1 : 1;
                        }
                    }
                    else if (index === 'PositionType') {
                        if (!isDesc) {
                            a.ServiceList = a.ServiceList.sort((c, d) => (c.PositionType > d.PositionType) ? 1 : -1)
                            b.ServiceList = b.ServiceList.sort((c, d) => (c.PositionType > d.PositionType) ? 1 : -1)
                            const aService = a.ServiceList[0].PositionType;
                            const bService = b.ServiceList[0].PositionType;
                            return aService < bService ? -1 : 1;
                        } else {
                            a.ServiceList = a.ServiceList.sort((c, d) => (c.PositionType < d.PositionType) ? 1 : -1)
                            b.ServiceList = b.ServiceList.sort((c, d) => (c.PositionType < d.PositionType) ? 1 : -1)
                            const aService = a.ServiceList[0].PositionType;
                            const bService = b.ServiceList[0].PositionType;
                            return bService < aService ? -1 : 1;
                        }
                    }
                    else if (index === 'States') {
                        if (!isDesc) {
                            a.ServiceList = a.ServiceList.sort((c, d) => (c.States > d.States) ? 1 : -1)
                            b.ServiceList = b.ServiceList.sort((c, d) => (c.States > d.States) ? 1 : -1)
                            const aService = a.ServiceList[0].States;
                            const bService = b.ServiceList[0].States;
                            return aService < bService ? -1 : 1;
                        } else {
                            a.ServiceList = a.ServiceList.sort((c, d) => (c.States < d.States) ? 1 : -1)
                            b.ServiceList = b.ServiceList.sort((c, d) => (c.States < d.States) ? 1 : -1)
                            const aService = a.ServiceList[0].States;
                            const bService = b.ServiceList[0].States;
                            return bService < aService ? -1 : 1;
                        }
                    }
                    else if (index === 'Parties') {
                        if (!isDesc) {
                            a.ServiceList = a.ServiceList.sort((c, d) => (c.Parties > d.Parties) ? 1 : -1)
                            b.ServiceList = b.ServiceList.sort((c, d) => (c.Parties > d.Parties) ? 1 : -1)
                            const aService = a.ServiceList[0].Parties;
                            const bService = b.ServiceList[0].Parties;
                            return aService < bService ? -1 : 1;
                        } else {
                            a.ServiceList = a.ServiceList.sort((c, d) => (c.Parties < d.Parties) ? 1 : -1)
                            b.ServiceList = b.ServiceList.sort((c, d) => (c.Parties < d.Parties) ? 1 : -1)
                            const aService = a.ServiceList[0].Parties;
                            const bService = b.ServiceList[0].Parties;
                            return bService < aService ? -1 : 1;
                        }
                    }
                    else if (index === 'Chambers') {
                        if (!isDesc) {
                            a.ServiceList = a.ServiceList.sort((c, d) => (c.Chambers > d.Chambers) ? 1 : -1)
                            b.ServiceList = b.ServiceList.sort((c, d) => (c.Chambers > d.Chambers) ? 1 : -1)
                            const aService = a.ServiceList[0].Chambers;
                            const bService = b.ServiceList[0].Chambers;
                            return aService < bService ? -1 : 1;
                        } else {
                            a.ServiceList = a.ServiceList.sort((c, d) => (c.Chambers < d.Chambers) ? 1 : -1)
                            b.ServiceList = b.ServiceList.sort((c, d) => (c.Chambers < d.Chambers) ? 1 : -1)
                            const aService = a.ServiceList[0].Chambers;
                            const bService = b.ServiceList[0].Chambers;
                            return bService < aService ? -1 : 1;
                        }
                    }
                    else {
                        if (!isDesc) {
                            return a[index] < b[index] ? -1 : 1;
                        } else {
                            return b[index] < a[index] ? -1 : 1;
                        }
                    }
                });
                return items;
            },        
            loadData() {
                this.loading = true;
                const partiesUrl ="parties?Select=pID,Name,Abbrev,Colour";
                axios.get(`api/${partiesUrl}`).then((response) => {
                    this.parties = response.data.value;
                });

                const url ="committees?Select=CID,CommitteeChamber,CommitteeType,CommitteeName";
                axios.get(`api/${url}`).then((response) => {
                    this.committee = response.data.value.find(OBJ => OBJ.CID == this.CID);
                    if (this.committee != null){
                        window.document.title = this.committee.CommitteeName + ' (' + this.committee.CommitteeType + ')';   
                    }
                });

                const committeeRecordsUrl = `committeemembers/` + this.CID + ``;
                axios.get(`api/${committeeRecordsUrl}`)
                .then(response => {
                    var records = response.data.value.map((item) => {
                        return {
                            details: {},
                            ...item
                        }
                    });

                    this.committeeRecords = records;

                    this.genderDemographics = [
                        { name: 'Women', data: records.filter((obj) => obj.Gender !== '19').length },
                        { name: 'Men', data: records.filter((obj) => obj.Gender == '19').length},
                    ];

                    axios.get(`api/committeeservicerecords/committeememberservice/${this.CID}`)
                    .then(response => {
                        this.committeeService = response.data.map((item) => {
                            return {
                                ...item
                            }
                        });

                        this.committeeRecords = this.committeeRecords.map(c => ({ ...c, ServiceList: this.committeeService.filter(s => s.PHID == c.PHID),
                         ParliamentList: this.committeeService.filter(s => s.PHID == c.PHID).map(s => s.ParliamentList).flat()}));

                        var recordParliaments = this.committeeRecords.map(s => s.ParliamentList).flat();
                   
                        this.ENABLED_PARLIAMENTS = this.$store.getters.GET_PARLIAMENTS_ORDERED.map(c => ({ ...c, 
                            disabled: recordParliaments.indexOf(c.PID) == -1 }));

                        this.committeeRecordsOriginal = this.committeeRecords.slice();

                        var memberService = this.committeeService.slice();

                        var memberServiceDemographics = memberService.reduce(function (r, a) {
                                r[a.PHID] = r[a.PHID] || { parties: [], chambers: [], states: []};
                                var parties = a.Parties.split(", ");
                                for (var i = 0; i < parties.length; i++) {
                                    var party = parties[i];
                                    if (r[a.PHID].parties.indexOf(party) === -1){
                                        r[a.PHID].parties.push(party);
                                    }
                                }
                                var chambers = a.Chambers.split(", ");
                                for (var j = 0; j < chambers.length; j++) {
                                    var chamber = chambers[j];
                                   if (r[a.PHID].chambers.indexOf(chamber) === -1){
                                        r[a.PHID].chambers.push(chamber);
                                    }
                                }
                                
                                var states = a.States.split(", ");
                                for (var k = 0; k < states.length; k++) {
                                    var state = states[k];
                                   if (r[a.PHID].states.indexOf(state) === -1){
                                        r[a.PHID].states.push(state);
                                    }
                                }
                                return r ;
                            }, Object.create(null));

                        
                        var memberServiceDemographicsObject = Object.values(memberServiceDemographics)
                        const memberServiceDemographicsPartiesArray = memberServiceDemographicsObject.map(({ parties }) => parties).flat();
                        const memberServiceDemographicsChambersArray = memberServiceDemographicsObject.map(({ chambers }) => chambers).flat();
                        const memberServiceDemographicsStatesArray = memberServiceDemographicsObject.map(({ states }) => states).flat();
                    
                        var partyDemographicsArray = memberServiceDemographicsPartiesArray.reduce(function(a, b){
                            a[b] = a[b] + 1 || 1
                            return a;
                        }, {});

                        this.partyDemographics = Object.keys(partyDemographicsArray).map(key => {
                            var partyColour = this.parties.find(p => p.Name == key).Colour
                            return { name: key, data: partyDemographicsArray[key], color: partyColour};
                        });

                        var chamberDemographicsArray = memberServiceDemographicsChambersArray.reduce(function(a, b){
                            a[b] = a[b] + 1 || 1
                            return a;
                        }, {});

                        this.chamberDemographics = Object.keys(chamberDemographicsArray).map(key => {
                            return { name: key == 'Member' ? 'House' : 'Senate', data: chamberDemographicsArray[key], 
                                color: key == 'Member' ? this.$store.state.COLOUR_REPRESENTATIVES : this.$store.state.COLOUR_SENATE};
                        });

                        var stateDemographicsArray = memberServiceDemographicsStatesArray.reduce(function(a, b){
                            a[b] = a[b] + 1 || 1
                            return a;
                        }, {});

                        this.stateDemographics = Object.keys(stateDemographicsArray).map(key => {
                            return { name: key.toUpperCase(), data: stateDemographicsArray[key]};
                        });
                           
                        this.FILTER_COMMITTEES();
                        this.loading = false;
                    }); 
                });
            },
            UPDATE_PAGINATION: function (options) {
                this.$gtag.event('committees by name pagination items per page', {
                    'event_category': 'filters',
                    'event_label': `items per page: ${options.rowsPerPage}`,
                    'value': 1
                });
                this.$gtag.event('committees by name pagination page', {
                    'event_category': 'filters',
                    'event_label': `page: ${options.page}`,
                    'value': 1
                });
                this.$gtag.event(`committees by name sorting`, {
                    'event_category': 'sorting',
                    'event_label': `sort by ${options.sortBy} ${options.descending ? 'DESC' : 'ASC'}`,
                    'value': 1
                });
                return this.PAGINATION;
            },
            TRACK_SEARCH: function () {
                if (this.search.length >= 3) {
                    this.$gtag.event('filter committee members - search', {
                        'event_category': 'filters',
                        'event_label': this.search,
                        'value': 1
                    });
                }
                this.FILTER_COMMITTEES();
            },
            getIndividual(PHID) {
                return this.committeeRecords.find(p => p.PHID === PHID);
            },
            GET_PARLIAMENTS_FROM_DATES(DateFrom, DateEnd) {
                var thisCommServiceStart = DateFrom && DateFrom.replace('T00:00:00Z', '') != "1900-01-01" && DateFrom.replace('T00:00:00Z', '') != "1900-01-1" ? this.$moment(DateFrom) : null;
                var thisCommServiceEnd = DateEnd && DateEnd.replace('T00:00:00Z', '') != "1900-01-01" && DateEnd.replace('T00:00:00Z', '') != "1900-01-1" ? this.$moment(DateEnd) : null;

                var allParliamentsSorted = this.$store.state.OBJ_PARLIAMENTS.sort((a, b) => a.PID < b.PID);
                var servedParliaments = [];
                var startParliament = undefined;

                // heavily relies on the sorted list to optimise logic and performances
                for (var i = 0; i < allParliamentsSorted.length; i++) {
                    var parliament = allParliamentsSorted[i];
                    var election = this.$moment(parliament.DateElection);
                    var dissolution = parliament.DateDissolution && parliament.DateDissolution != "1900-01-01" && parliament.DateDissolution != "1900-01-1" ? this.$moment(parliament.DateDissolution) : null;
                    if (!startParliament) {
                        if (thisCommServiceStart && thisCommServiceStart >= election && (!dissolution || thisCommServiceStart < dissolution)) {
                            startParliament = parliament;
                            servedParliaments.push(parliament);
                        }
                    } else {

                        if (!thisCommServiceEnd
                            || (thisCommServiceEnd && dissolution && election <= thisCommServiceEnd && thisCommServiceEnd <= dissolution)
                            || (thisCommServiceEnd && dissolution && dissolution <= thisCommServiceEnd)
                            || (thisCommServiceEnd && !dissolution && thisCommServiceEnd >= election)) {
                            servedParliaments.push(parliament);
                        } else {
                            break;
                        }
                    }
                }

                return servedParliaments.map(p => p.PID);

            },
            EXPORT_COMMITTEE_CSV: function () {
                this.$gtag.event(`committee ${`${this.committee.CommitteeType} - ${this.committee.CommitteeName}`} download csv`, {
                    'event_category': 'downloads',
                    'event_label': `committee ${`${this.committee.CommitteeType} - ${this.committee.CommitteeName}`} csv download`,
                    'value': 1
                });

                this.csvDownloading = true;

                let thisCommittee = this.committeeService;
                let OBJ_records = [];
                let headers = ['Name', 'PHID', 'Position', 'Party', 'State', 'Chamber', 'Start Date', 'End Date'];
                let filename = `${this.committee.CommitteeType} - ${this.committee.CommitteeName}`
                let index = 0;

                //  then we progressively build up the  exportOBJ
                for (index = 0; index < thisCommittee.length; ++index) {
                    var parliamentarian = this.committeeRecordsOriginal.find(s => s.PHID == thisCommittee[index].PHID);
                    OBJ_records.push({
                        'Name': parliamentarian.Name,
                        'PHID': thisCommittee[index].PHID,
                        'Position': thisCommittee[index].PositionType,
                        'Chamber': thisCommittee[index].Chambers.replace('Member', 'House').replace('Senator', 'Senate'),
                        'Party': thisCommittee[index].Parties,
                        'State': thisCommittee[index].States,
                        'Start Date': thisCommittee[index].StartDate != null ? this.formatDate(thisCommittee[index].StartDate, '', 'YYYY-MM-DD', false): 'current',
                        'End Date': thisCommittee[index].EndDate != null ? this.formatDate(thisCommittee[index].EndDate, '', 'YYYY-MM-DD', false) : 'current',
                    });
                }
                this.$store.dispatch('GETCSV', { DATA: OBJ_records, HEADERS: headers, FILENAME: filename })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
                thisCommittee = null;
                OBJ_records = null;
                index = null;
            },
            EXPORT_COMMITTEE_PDF: function () {
                this.$gtag.event(`committee ${`${this.committee.CommitteeType} - ${this.committee.CommitteeName}`} download pdf`, {
                    'event_category': 'downloads',
                    'event_label': `committee ${`${this.committee.CommitteeType} - ${this.committee.CommitteeName}`} pdf download`,
                    'value': 1
                });

                this.pdfDownloading = true;
                let url = `${this.$store.state.URL_API}/document/committee`;
                let committeeModel = { Parliament: -1, DisplayName: `${this.committee.CommitteeType} - ${this.committee.CommitteeName}`, Members: [] }
                let thisCommittee = this.committeeService;
                for (let index = 0; index < this.RECORDS1.length; ++index) {
                    committeeModel.Members.push({
                        DisplayName: `${this.committee.CommitteeType} - ${this.committee.CommitteeName}`,
                        PHID: thisCommittee[index].PHID,
                        MemberType: thisCommittee[index].PositionType,
                        MpOrSenator: thisCommittee[index].Chambers,
                        Party: thisCommittee[index].Parties,
                        StartDate: thisCommittee[index].StartDate != null ? this.formatDate(thisCommittee[index].StartDate, '', 'YYYY-MM-DD', false): 'current',
                        EndDate: thisCommittee[index].EndDate != null ? this.formatDate(thisCommittee[index].EndDate, '', 'YYYY-MM-DD', false) : 'current',
                    });
                }

                axios.post(url, committeeModel, { responseType: 'arraybuffer' })
                    .then((response) => {
                        let blob = new Blob([response.data], { type: 'application/pdf' }),
                            downloadUrl = window.URL.createObjectURL(blob),
                            name = `${`${this.committee.CommitteeType} - ${this.committee.CommitteeName}`}`,
                            filename = `Committee [${name}].pdf`

                        let a = document.createElement("a");
                        if (typeof a.download === "undefined") {
                            window.location.href = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                        a.remove();
                    }).catch(this.showError)
                    .finally(() => this.pdfDownloading = false);
            },
            FILTER_COMMITTEES: function () {
                // create a function scoped var to hold all Committees
                let OBJ_records = this.committeeRecordsOriginal.slice();
                let index = 0;

                var currentObjRecords = [];
                if (this.SELECTED_PARLIAMENTS.length == 0){
                    currentObjRecords = OBJ_records;
                }

                for (index = 0; index < this.SELECTED_PARLIAMENTS.length; ++index) {
                    var internalRecords = OBJ_records;

                    //  FILTERS_SELECTED_PARLIAMENTS
                    var parliament = this.$store.getters.GET_PARLIAMENT_BYPID(
                        parseInt(this.SELECTED_PARLIAMENTS[index])
                    );
                    if (!parliament) {
                        continue;
                    }

                    var existingIDs = currentObjRecords.map((obj) => obj.PHID);

                    var filtered = internalRecords
                        .filter((Obj) => Obj.ParliamentList.indexOf(parliament.PID) > -1 && existingIDs.indexOf(Obj.PHID) == -1)
                        .map(c => ({ ...c, ServiceList: c.ServiceList.filter(s => s.ParliamentList.indexOf(parliament.PID) > -1)}));

                    currentObjRecords = currentObjRecords.concat(filtered);
                }

                for (var i = 0; i < currentObjRecords.length; i++) {
                    var record = currentObjRecords[i];

                    var truncateStates = [...new Set(record.ServiceList.map(m => m.States))].length == 1;
                    record.States = record.ServiceList.map(m => m.States.toLowerCase()).flat().join(',');
                    if (truncateStates) {
                        record.TruncateStates = true;
                    }

                    var truncateParties = [...new Set(record.ServiceList.map(m => m.Parties))].length == 1;
                    record.Parties = record.ServiceList.map(m => m.Parties.toLowerCase()).flat().join(',');
                    if (truncateParties) {
                        record.TruncateParties = true;
                    }

                    var truncateChambers = [...new Set(record.ServiceList.map(m => m.Chambers))].length == 1;
                    record.Chambers = record.ServiceList.map(m => m.Chambers.replace('Member', 'House').replace('Senator', 'Senate').toLowerCase()).flat().join(',');
                    if (truncateChambers) {
                        record.TruncateChambers = true;
                    }
                   
                    var truncatePositions = [...new Set(record.ServiceList.map(m => m.PositionType))].length == 1;
                    record.PositionTypes = record.ServiceList.map(m => m.PositionType.toLowerCase()).flat().join(',');
                    if (truncatePositions) {
                        record.TruncatePositions = true;
                    }

                    currentObjRecords[i] = record;
                }

                if (this.search != '') {
                    var searchTerm = this.search.toLowerCase().toString();
                    currentObjRecords = currentObjRecords.filter(r => ( r.Name.toLowerCase().indexOf(searchTerm) > -1
                    || r.States.indexOf(searchTerm) > -1
                    || r.PositionTypes.indexOf(searchTerm) > -1
                    || r.Parties.indexOf(searchTerm) > -1
                    || r.Chambers.indexOf(searchTerm) > -1))
                }

                this.committeeRecords = currentObjRecords;

            

                let query = this.$router.query || {};

                if (this.SELECTED_PARLIAMENTS.length > 0) {
                    query.parliaments = this.SELECTED_PARLIAMENTS.join(",");
                }

                if (this.search) {
                    query.s = this.search;
                }

                if (Object.keys(query).length > 0) {
                    history.replaceState({},null,
                        this.$route.path +"?" +
                        Object.keys(query).map((key) => {
                            return key + "=" + query[key];
                        }).join("&")
                    );
                } else {
                    history.replaceState({}, null, this.$route.path);
                }

                return true;
            },
            FILTERBY_PARLIAMENT: function (parliaments) {
                this.$gtag.event("committees by parliament parliament filter", {
                    event_category: "filters",
                    event_label: `parliaments selected: ${
                    parliaments.length > 0 ? parliaments.join(",") : "none"
                    }`,
                    value: 1,
                });
                return this.FILTER_COMMITTEES();
            },
            CLICK_CURRENTPARLIAMENT: function () {
                this.$nextTick(() => {
                    let parliaments = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                    let currentParliament = parliaments[0].PID;
                    if (this.SELECTED_PARLIAMENTS.includes(currentParliament)) {
                        let index = this.SELECTED_PARLIAMENTS.indexOf(currentParliament);
                        if (index > -1) {
                            this.SELECTED_PARLIAMENTS.splice(index, 1);
                        }
                    } else {
                        this.SELECTED_PARLIAMENTS.push(currentParliament);
                    }
                    this.FILTERBY_PARLIAMENT(this.SELECTED_PARLIAMENTS);
                });
            }
        },
        mounted() {
            this.onResize();
            //Set page to 10 on mobile, only on mount
            if (this.isMobile){
                this.PAGINATION.rowsPerPage = 10;
            }

            if (this.parliaments != null && this.parliaments.length > 0){
                this.SELECTED_PARLIAMENTS = this.parliaments.map(p => parseInt(p));
            } else {
                if (this.$route.query.parliaments) {
                    this.SELECTED_PARLIAMENTS = this.$route.query.parliaments.split(',').map(p => parseInt(p));
                }
            }

            if (this.$route.query.s) {
                this.search = this.$route.query.s;
            }

            this.FILTER_COMMITTEES();
        },
        computed: {
            committeeStateDemographics() {
                const series = this.stateDemographics.map((h) => ({
                    name: h.name,
                    data: [h.data],
                    pointWidth:20,
                    visible: true,
                    showInLegend: false,
                     groupPadding: 0
                }));
                const categories = ['State'];

                return {
                    chart: {
                        type: 'bar',
                        height:50,
                        marginLeft: 100
                    },
                    exporting: {
                        enabled: false,
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        categories: categories,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    yAxis:{
                        visible: false,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    tooltip: {
                        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y} committee members</b> ({point.percentage:.0f}%)<br/>',
                    },
                    plotOptions: {
                        bar: {
                            stacking: 'percent'
                        }
                    },
                    legend: {
                        visible: false
                    },
                    series: series
                };
            },
            committeePartyDemographics() {
                const series = this.partyDemographics.map((h) => ({
                    name: h.name,
                    data: [h.data],
                    color: h.color,
                    pointWidth:20,
                    visible: true,
                    showInLegend: false,
                     groupPadding: 0
                }));
                const categories = ['Party'];

                return {
                    chart: {
                        type: 'bar',
                        height:50,
                        marginLeft: 100
                    },
                    exporting: {
                        enabled: false,
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        categories: categories,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    yAxis:{
                        visible: false,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    tooltip: {
                        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y} committee members</b> ({point.percentage:.0f}%)<br/>',
                    },
                    plotOptions: {
                        bar: {
                            stacking: 'percent'
                        }
                    },
                    legend: {
                        visible: false
                    },
                    series: series
                };
            },
            committeeChamberDemographics() {
                const series = this.chamberDemographics.map((h) => ({
                    name: h.name,
                    data: [h.data],
                    color: h.color,
                    pointWidth:20,
                    visible: true,
                    showInLegend: false
                }));
                const categories = ['Chamber'];

                return {
                    chart: {
                        type: 'bar',
                        height:50,
                        marginLeft: 100
                    },
                    exporting: {
                        enabled: false,
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        categories: categories,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    yAxis:{
                        visible: false,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    tooltip: {
                        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y} committee members</b> ({point.percentage:.0f}%)<br/>',
                    },
                    plotOptions: {
                        bar: {
                            stacking: 'percent'
                        }
                    },
                    legend: {
                        visible: false
                    },
                    series: series
                };
            },
            committeeGenderDemographics() {
                const series = this.genderDemographics.map((h) => ({
                    name: h.name,
                    data: [h.data],
                    pointWidth:20,
                    visible: true,
                    showInLegend: false
                }));
                const categories = ['Gender'];

                return {
                    chart: {
                        type: 'bar',
                        height:50,
                        marginLeft: 100
                    },
                    exporting: {
                        enabled: false,
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        categories: categories,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    yAxis:{
                        visible: false,
                        minPadding: 0,
                        maxPadding: 0
                    },
                    tooltip: {
                        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y} committee members</b> ({point.percentage:.0f}%)<br/>',
                    },
                    plotOptions: {
                        bar: {
                            stacking: 'percent'
                        }
                    },
                    legend: {
                        visible: false
                    },
                    series: series
                };
            },
            pdfDownloadIcon(){
                return this.pdfDownloading ? 'cached' : 'picture_as_pdf';
            },
            pdfDownloadClass(){
                let pdfClass = 'mr-1';
                if (this.pdfDownloading){
                    pdfClass = pdfClass + ' loading'
                }
                return pdfClass;
            },
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            currentParliamentIcon: function () {
                let parlArray = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                let currentParliament = parlArray[0].PID;
                if (this.SELECTED_PARLIAMENTS.indexOf(currentParliament) > -1) {
                    return '$vuetify.icons.checkboxOn';
                } else {
                    return '$vuetify.icons.checkboxOff';
                }
            },
            currentParliamentValue: function () {
                let parlArray = this.$store.getters.GET_PARLIAMENTS;
                if (this.SELECTED_PARLIAMENTS.includes(parlArray[parlArray.length - 1].PID)) {
                    return parlArray[parlArray.length - 1].PID;
                } else {
                    return false;
                }
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            }
        },
        beforeDestroy() {
            // this.unwatch();
        }

    }
</script>
<style lang="stylus" scoped>
    .handbook-tablecol_linebreaks {
        white-space: pre;
    }

    .v-datatable .tr {
        display:table-row;
    }

    .v-datatable a.tr {
        color: #0e1531de;
        text-decoration:none;
        border: 1px solid #dbdbdb;
        border-left: none;
        border-right: none;
    }

  table.v-table tbody td {
    vertical-align: middle;
}

    .v-datatable >>> .v-image {
        height:100px;
    }

     @media screen and (max-width: 1420px) {
        .stats-table >>> table.v-table thead td:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody td:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead th:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody th:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead td:first-child, 
        .stats-table >>> table.v-table tbody td:first-child, 
        .stats-table >>> table.v-table thead th:first-child, 
        .stats-table >>> table.v-table tbody th:first-child,
        .stats-table >>> table.v-table thead th:first-child {
            padding: 0 14px !important;
        }

        .stats-table >>> th {
            white-space: break-spaces;
        }
    }

</style>
